"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const uicon_download_style_1 = __importDefault(require("./uicon.download.style"));
class UiconDownload extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, size } = this.props;
            return (jsx_runtime_1.jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", viewBox: "0 0 32 32", "aria-hidden": "true", className: classes.root, style: { width: size, height: size } }, { children: [jsx_runtime_1.jsx("path", { d: "M24.462 20.428V23.728C24.462 24.095 23.862 24.506 23.062 24.506H8.7C7.9 24.506 7.3 24.095 7.3 23.728V20.428H6V23.728C6 24.893 7.186 25.806 8.7 25.806H23.06C24.575 25.806 25.76 24.893 25.76 23.728V20.428H24.462Z", className: classes.fill }, void 0),
                    jsx_runtime_1.jsx("path", { d: "M15.88 21.334C16.1348 21.3343 16.3872 21.2843 16.6226 21.1868C16.8581 21.0894 17.072 20.9464 17.252 20.766L21.9 16.118L20.981 15.199L16.53 19.65V7H15.23V19.65L10.78 15.199L9.86099 16.118L14.509 20.766C14.6889 20.9462 14.9026 21.0892 15.1379 21.1867C15.3731 21.2841 15.6253 21.3342 15.88 21.334Z", className: classes.fill }, void 0)] }), void 0));
        };
    }
}
UiconDownload.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    size: prop_types_1.default.number
};
UiconDownload.defaultProps = {
    size: null
};
exports.default = react_jss_1.default(uicon_download_style_1.default)(UiconDownload);
//# sourceMappingURL=uicon.download.js.map